// @flow
import React from "react";
import LinkViewerControl from "./LinkViewerControl";

type Props = {
    name: string,
    header?: string,
    value: ?string,
    width?: number,
    isGridCell: boolean,
};

const TelViewerControl = ({
    name,
    header,
    value,
    width,
    isGridCell,
}: Props) => (
    <LinkViewerControl
        name={name}
        header={header}
        linkType="tel"
        value={value}
        icon="phone"
        isGridCell={isGridCell}
        isIconLast={false}
    />
);
TelViewerControl.displayName = "TelViewerControl";
export default TelViewerControl;
